export enum StorageType {
  Fixed = 1,            // Cố định
  Session = 2,          // Phiên
  ConcurrentMeeting = 3 // Theo số cuộc họp đồng thời
}

// Map enum sang text
const storageTypeText: Record<StorageType, string> = {
  [StorageType.Fixed]: 'Cố định',
  [StorageType.Session]: 'Phiên',
  [StorageType.ConcurrentMeeting]: 'CH đồng thời'
};

// Hàm tiện ích
export function getStorageTypeLabel(type: number): string {
  return storageTypeText[type as StorageType] ?? '';
}
